/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowDownLeftSmall: {
  name: 'arrow_down_left_small';
  data: string;
} = {
  name: 'arrow_down_left_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M7.747 9.625a.75.75 0 0 1 1.5 0v3.814l5.473-5.472a.75.75 0 1 1 1.06 1.06L10.31 14.5h3.813a.75.75 0 0 1 0 1.5H8.498a.75.75 0 0 1-.75-.75V9.624Z" fill="currentColor"/></svg>`
};
